import { html } from "htm/preact";
import { Icon } from "./Icon.js";
import type { ConnStatus } from "../client.js";

export function ConnBanner({
  status,
  outboxSize,
  lastError,
}: {
  status: ConnStatus;
  outboxSize: number;
  lastError?: string | null;
}) {
  if (lastError) {
    return html`<div class="conn-banner error">
      <${Icon} name="alert" size=${16} /> Couldn't save a change: ${lastError}
    </div>`;
  }
  if (status === "online" && outboxSize === 0) return null;

  const label =
    status === "offline"
      ? `Offline — ${outboxSize} ${outboxSize === 1 ? "change" : "changes"} not yet synced`
      : status === "connecting"
        ? "Connecting…"
        : `Syncing ${outboxSize} ${outboxSize === 1 ? "change" : "changes"}…`;

  return html`<div class="conn-banner ${status}"><span class="dot"></span> ${label}</div>`;
}
